import 'jquery';
import 'bootstrap';
window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js')
import 'owl.carousel';
import 'eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min';
import amplitude from 'amplitude-js';

var mobile = require('is-mobile');

$(() => {
    var w = $('.b-profile-fields__slider_wrapper').width();
    var w_num = $('.b-profile-fields__slider .b-profile-fields-wrapper').length;
    var ww = 1;

    profileResize(w_num);

    $('#b-profile-continue').on('click',function (e){
        e.preventDefault();

        $('.b-profile-fields__slider').css('transform', 'translateX(-'+w*ww+'px)');
        ww++;
        if (ww == w_num) {
            $('#b-profile-continue').remove();
            return false;
        }

        $("html, body").animate({ scrollTop: 0 }, 300);
    })
    $('.yi-select-all').on('click',function(e){
        var check = false;
        if($(this).is(':checked')) {
            check = true;
        }
        $(this).parents('.form-check').children('.form-group').find('input:checkbox').prop('checked', check);
    });

    $(document).on('click', '.user-info', function(e){
        e.preventDefault();
        var title = $(this).attr('title');
        if (title.length > 0){
            $(this).parent().append('<div class="user-info-content">' + title + '</div>');
        }else {
            $('.user-info-content').remove();
        }
    });

    $('.navbar-toggler').on('click', function(){
        if (!$('body').hasClass('landing')) {
            $('body').toggleClass('menuopen');
        }
        $('#navbarText').toggleClass('show');
    });
 $('.date-picker').datetimepicker({
     format: 'yyyy-mm-DD',
     icons: {
         time: "bi bi-clock",
         date: "bi bi-calendar-date",
         up: "bi-chevron-up",
         down: "bi-chevron-down",
         previous: "bi bi-chevron-left",
         next: "bi bi-chevron-right"
     }
 });

    $('.date-timepicker_start').datetimepicker({
        format: 'yyyy-MM-DD HH:mm',
        sideBySide: true,
        icons: {
            time: "bi bi-clock",
            date: "bi bi-calendar-date",
            up: "bi-chevron-up",
            down: "bi-chevron-down",
            previous: "bi bi-chevron-left",
            next: "bi bi-chevron-right"
        }
    });

    $('.date-timepicker_finish').datetimepicker({
        useCurrent: false,
        format: 'yyyy-MM-DD HH:mm',
        sideBySide: true,
        icons: {
            time: "bi bi-clock",
            date: "bi bi-calendar-date",
            up: "bi-chevron-up",
            down: "bi-chevron-down",
            previous: "bi bi-chevron-left",
            next: "bi bi-chevron-right"
        }
    });

    $(".date-timepicker_start").on("dp.show", function (e) {
        $('.date-timepicker_start+.bootstrap-datetimepicker-widget .timepicker-picker').prepend('<div class="pt-2 d-flex justify-content-center align-content-center">Please select start time</div>');
    });

    $(".date-timepicker_finish").on("dp.show", function (e) {
        $('.date-timepicker_finish+.bootstrap-datetimepicker-widget .timepicker-picker').prepend('<div class="pt-2 d-flex justify-content-center align-content-center">Please select finish time</div>');
    });

    $(".date-timepicker_start").on("dp.change", function (e) {
        $('.date-timepicker_finish').data("DateTimePicker").minDate(e.date);
    });
    $(".date-timepicker_finish").on("dp.change", function (e) {
        $('.date-timepicker_start').data("DateTimePicker").maxDate(e.date);
    });

// header menu
        function addClassMenu() {
            var height = $(window).scrollTop(),
                menu = '.yi-landing-header-menu',
                add_class = 'bg-color';
            if (height > 0) {
                $(menu).addClass(add_class);
            } else {
                $(menu).removeClass(add_class);
            }
        }
        addClassMenu();
        $(window).scroll(function() {
            addClassMenu();
        });
// sliders init
        $('.yi-landing-about').owlCarousel({
            loop: true,
            items: 3,
            smartSpeed: 500,
            responsiveRefreshRate: 1,
            responsive:{
                0:{
                    items: 1,
                    dots: true,
                    margin: 0
                },
                992:{
                    items: 3,
                    dots: false,
                    mouseDrag: false,
                    margin: 32
                },
                1200:{
                    margin: 74
                }
            }
        });
        $('.yi-landing-partners').owlCarousel({
            center: true,
            items: 1,
            smartSpeed: 500,
            loop: true,
            dots: false,
            autoplay: true,
            slideTransition: 'linear',
            autoplayTimeout: 4500,
            autoplayHoverPause: true,
            autoplaySpeed: 4500,
            autoWidth: true,
            margin: 0
        });
        $('.yi-landing-reviews').owlCarousel({
            loop: true,
            nav: true,
            navText: ["<div class='yi-landing-arrow'></div>","<div class='yi-landing-arrow'></div>"],
            dots: false,
            items: 1,
            smartSpeed: 800
        });


 /*$('.yi-date-picker input').on('click',function (){
     $(this).parent().find('.datepicker').toggleClass('open');
 });
 $('input').not('.date-picker').on('focus', function(){
     $('.datepicker').removeClass('open');
 });*/

    $(document).on('click', '#removeAvatar, #uploadAvatar', function(e){
        e.preventDefault();
        $('.cropper-buttons .delete-photo').click();
        $('.new-photo-area').show();
        $('#accept_icon').css('display','flex');
        $('.progress').css('visibility','visible');
        //$('#removeAvatar').attr('id','uploadAvatar').find('use').attr('xlink:href','#plus-icon');
    });

    $(document).on('click', '#accept_icon', function(e){
        e.preventDefault();
        $('.cropper-buttons .crop-photo').click();
        $('.new-photo-area').hide();
        $('.progress').css('visibility','hidden');
        $(this).hide();
    });
    $( window ).resize(function() {
        setTimeout(profileResize, 500, w_num);
    });
});

function profileResize (w_num) {
    var w = $('.b-profile-fields__slider_wrapper').width();
    $('.b-profile-fields__slider').width(w*w_num);
}

function resizeIframe(obj) {
    obj.style.height = obj.contentWindow.document.documentElement.scrollHeight + 'px';
}